import { render, staticRenderFns } from "./wikiPageCreate.vue?vue&type=template&id=9c37503a&"
import script from "./wikiPageCreate.vue?vue&type=script&lang=ts&"
export * from "./wikiPageCreate.vue?vue&type=script&lang=ts&"
import style0 from "./wikiPageCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports